<template>
	<div>
	</div>
</template>

<script>
	export default {
		data() {
			return {

			}
		},
		methods: {
			getQueryString(name) {
				var after = window.location.hash.split("?")[1];
				if (after) {
					var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
					var r = after.match(reg);
					if (r != null) {
						return decodeURIComponent(r[2]);
					} else {
						return null;
					}
				}
			},
			GetCode() {
				let code = this.getQueryString('code')
				if (code != null) {
					let cnt = {
						code: code,
						type: 'pc'
					}
					this.$api.login(cnt, (res) => {
						if (res.data.rc == this.$util.RC.SUCCESS) {
							let obj = JSON.parse(res.data.c)
							if (obj.status) {
								localStorage.setItem('user', res.data.c)
								this.$router.push({
									path: '/'
								})
								// 信息已经填完整 正常流程
							} else {
								sessionStorage.setItem('openId', obj.oId)
								sessionStorage.setItem('unionId', obj.uId)
								sessionStorage.setItem('nickName', obj.nickName)
								sessionStorage.setItem('headImg', obj.headImg)
								// 信息没有填完整 跳转到注册页 带上把code填写注册信息
								this.$router.push({
									path: '/register',
									query: {
										unionId: obj.uId,
										openId: obj.oId,
										nickName: obj.nickName,
										headImg: obj.headImg
									}
								})
							}
						} 
					});
				}
			}
		},
		created() {
			this.GetCode()
		}
	}
</script>

<style scoped>
	.signin {
		width: 430px;
		/* background-color: darkgoldenrod; */
		margin: 80px auto;
	}

	.head {
		width: 980px;
		margin: 0 auto;
		padding-right: 16px;

	}

	.retrun {
		margin-top: 10px;
		cursor: pointer;
		margin-left: 10px;
	}

	.retrun:hover {
		color: #596d84;
	}

	.title {
		font-size: 18px;
		font-weight: bold;
		color: #333;
		text-align: center;
	}

	.flex {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.signinbtn {
		background-image: linear-gradient(to right, #5173ff, #3dbbff);
	}

	.zucbtn {
		background-image: linear-gradient(to right, #ff8251, #ffb33d);
		border: none;
	}

	@media (max-width: 980px) {
		.head {
			width: 100%;
		}
	}

	@media (max-width: 680px) {
		.signin {
			width: 70%;
			margin: 0 auto;
		}
	}
</style>
